module.exports = __webpack_public_path__ + "static/OpenSans-BoldItalic-127782cd1371d1dad12acaa7712e77f3.woff";